import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../modules/common/services/authentication/authentication.service';
import { TokenService } from '../modules/common/services/token.service';

@Injectable()
export class AppLanguageService {

  constructor(private tokenService: TokenService, private authenticationService: AuthenticationService, private route: ActivatedRoute) { }

  public getStartingLanguage(): Observable<string> {
    return this.route.queryParams.pipe(
      map(params => {
        const culture = params['culture'];
        const lang = params['lang'];
        const country = params['country'];
        let result = navigator.language;
        if (this.authenticationService.isUserLoggedIn()) {
          result = this.tokenService.getCulture();
        }
        else if (culture){
          result = culture;
        }
        else if (lang) {
          result = `${lang.toLowerCase()}${country && country != '' && `-${country.toUpperCase()}`}`;
        }
        return result;
      })
    );
  }
}